module.exports = __webpack_public_path__ + "img/8.48c53b33.png";